import { API } from "./api";

// ONE centralized capture-phase handler for EVERY outbound affiliate click (including
// dynamically rendered anchors and new-tab clicks). It fires a non-blocking first-party
// beacon BEFORE navigation, so the visitor still reaches Travelpayouts normally. The /go
// endpoint also logs server-side; the backend dedupes so one physical click = one event.
export function installOutboundTracking() {
  if (typeof document === "undefined" || window.__hs_outbound_installed) return;
  window.__hs_outbound_installed = true;
  document.addEventListener("click", (e) => {
    const anchor = e.target && e.target.closest ? e.target.closest('a[href*="/api/go"]') : null;
    if (!anchor) return;
    try {
      const url = new URL(anchor.href, window.location.origin);
      const params = Object.fromEntries(url.searchParams.entries());
      params.via = "beacon";
      const body = JSON.stringify(params);
      if (navigator.sendBeacon) {
        navigator.sendBeacon(`${API}/click`, new Blob([body], { type: "application/json" }));
      } else {
        fetch(`${API}/click`, { method: "POST", body, headers: { "Content-Type": "application/json" }, keepalive: true }).catch(() => {});
      }
    } catch (_) { /* never block the outbound journey */ }
  }, true); // capture phase → fires even when other handlers stopPropagation
}
